import { pluralize } from '../pluralize';

export type ScheduleUnit = 'minute' | 'hour' | 'day';

const MAP_UNITS_TO_STRING: Record<ScheduleUnit, [string, string, string]> = {
    minute: ['Каждую %d минуту', 'Каждые %d минуты', 'Каждые %d минут'],
    hour: ['Каждый %d час', 'Каждые %d часа', 'Каждые %d часов'],
    day: ['Каждый %d день', 'Каждые %d дня', 'Каждые %d дней'],
};

export const scheduleToString = (period: number, timeUnit: ScheduleUnit) =>
    pluralize(period, ...MAP_UNITS_TO_STRING[timeUnit]);
